import { render, staticRenderFns } from "./Features.vue?vue&type=template&id=63dc0769&"
import script from "./Features.vue?vue&type=script&lang=ts&"
export * from "./Features.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports